<template>
  <el-dropdown trigger="click" class="international" @command="handleSetLanguage">
    <svg-icon class-name="international-icon" icon-class="language" />
    <template #dropdown>
      <el-dropdown-menu>
        <el-dropdown-item command="pl" :disabled="currentLocale === 'pl'">PL</el-dropdown-item>
        <el-dropdown-item command="en" :disabled="currentLocale === 'en'">ENG</el-dropdown-item>
        <el-dropdown-item command="ru" :disabled="currentLocale === 'ru'">RU</el-dropdown-item>
      </el-dropdown-menu>
    </template>
  </el-dropdown>
</template>

<script lang="ts" setup>
import { useLocaleSwitch } from '@/lang/useLocaleSwitch'

const { switchLocale, currentLocale } = useLocaleSwitch()

async function handleSetLanguage(newLocale) {
  await switchLocale(newLocale)
}
</script>

<style scoped>
.international-icon {
  font-size: 20px;
  cursor: pointer;
  vertical-align: -5px !important;
}
</style>
